import IconRemove from '../../../assets/icons/icon-remove.svg'
import * as S from './styles'
import Select from '../../Select'
import { useState } from 'react'
import { removerCartao } from './fetch'
import { useToast } from '../../../hooks/toast'

import CreditCardImage from '../CreditCardImage'
import { showFullFlagName } from '../../../utils/utils'
import pagamento from '../../../api/pagamento'

const CreditCard = ({
  data,
  type,
  check,
  setCheck,
  deleteModal,
  current,
  setCurrent,
  setLoader
}) => {
  const { addToast } = useToast()

  const [showOptions, setShowOptions] = useState({
    showOptions: false
  })
  // const [cardSelected, setCardSelected] = useState(false)
  // const [checked, setChecked] = useState({
  //   checked: false
  // })

  const handleShowSelected = (cardDetail) => {
    setShowOptions({
      [cardDetail]: !showOptions[cardDetail]
    })
  }

  const handleMockDeleteCard = async (id) => {
    setLoader(true)

    await pagamento
      .delCartao(id)
      .then((response) => {
        if (response) setLoader(false)

        if (response.ok) {
          addToast({
            type: 'success',
            title: 'Cartão excluído'
          })
        } else if (response.status !== 200) {
          setLoader(false)
          addToast({
            type: 'error',
            title: 'Erro ao excluir Cartão'
          })
        }
      })
      .catch((error) => {
        if (error) setLoader(false)
        addToast({
          type: 'error',
          title: 'Erro ao excluir Cartão',
          description: `${error}`
        })
      })
    current === 0 ? setCurrent(3) : setCurrent(0)
    // setShowModal(false)
  }

  return (
    <>
      <S.Wrapper className="">
        <S.CardWrapper className="">
          <S.CardBox className="perfil-box">
            {type === 'modal' && (
              <S.MainCard>
                <input
                  type="radio"
                  id={`card${data.IdCartao}`}
                  name={data.IdCartao}
                  readOnly
                  checked={check.IdCartao == data.IdCartao}
                  onClick={async (e) => {
                    setCheck(data)
                  }}
                />
                <label htmlFor={`card${data.IdCartao}`}></label>
              </S.MainCard>
            )}

            <CreditCardImage cartao={data.Brand}></CreditCardImage>

            <S.CardInfo>
              {/* {type === 'modal' ? (
                <p>
                  <strong>{data.bandeira} </strong>Final {data.numero}
                  <p>{data.nome}</p>
                  <p>Vencimento: {data.vencimento}</p>
                </p>
              ) : (
                <p>
                  <strong>{data.bandeira} </strong>Final {data.numero}
                  <p>Em até 12x sem Juros</p>
                </p>
              )} */}
              <p>
                <strong>{showFullFlagName(data.Brand)}</strong> Final{' '}
                {data.MaskedNumber.slice(-4)}
              </p>
            </S.CardInfo>

            <S.CardIcon
              onClick={() => {
                if (type !== 'modal') {
                  deleteModal(data.IdCartao)
                } else {
                  handleMockDeleteCard(data.IdCartao)
                }
              }}
            >
              <img src={IconRemove} alt="Remover Cartão" />
            </S.CardIcon>
          </S.CardBox>
        </S.CardWrapper>
      </S.Wrapper>
    </>
  )
}

export default CreditCard
